import React, { useState } from 'react';
import classnames from 'classnames/bind';
import styles from './InitialView.module.scss';
import { Button } from '@components';
import ImageIcon from '@mui/icons-material/Image';
import { Icon, Input, InputFile, Label, Typography } from 'gd-design-library';
import { PlacementCheckResponse } from '@services';

const cx = classnames.bind(styles);

const CN = 'initial-view';
const actionButtonsClassName = `${CN}__action-buttons`;
const checkboxLabelClassName = `${CN}__checkbox-label`;

interface InitialViewProps {
  placementCheck: PlacementCheckResponse | null;
  sceneImage: File | null;
  setSceneImage: (file: File | null) => void;
  notes: string;
  setNotes: (notes: string) => void;
  generatePlacement: (generateVideo: boolean) => Promise<void>;
  isGeneratingImage: boolean;
}

export const InitialView: React.FC<InitialViewProps> = ({
  placementCheck,
  sceneImage,
  setSceneImage,
  notes,
  setNotes,
  generatePlacement,
  isGeneratingImage
}) => {
  const [ generateVideo, setGenerateVideo ] = useState(false);

  return (
    <div className={ cx(CN) }>
      <Typography>
        {placementCheck?.instruction}
      </Typography>
      <InputFile
        accept='image/*'
        disabled={ isGeneratingImage }
        onChange={ (event: React.ChangeEvent<HTMLInputElement>): void => {
          setSceneImage(event.target.files?.[0] || null);
        } }
        buttonProps={ { iconStart: <Icon name='upload' width={ 14 } height={ 14 } /> } }
      >
        {sceneImage?.name ? sceneImage?.name.slice(0, 20) + (sceneImage?.name.length > 20 ? '...' : '') : 'Select image'}
      </InputFile>
      <Input
        placeholder='Notes'
        value={ notes }
        disabled={ isGeneratingImage }
        onChange={ (event: React.ChangeEvent<HTMLInputElement>): void => {
          setNotes(event.target.value);
        } }
        onKeyDown={ (event: React.KeyboardEvent<HTMLInputElement>): void => {
          if (event.key === 'Enter' && sceneImage && !isGeneratingImage) {
            generatePlacement(false);
          }
        } }
      />
      <div className={ cx(actionButtonsClassName) }>
        <Label className={ cx(checkboxLabelClassName) }>
          <Input
            name='generateVideo'
            role='checkbox'
            variant='checkbox'
            checked={ generateVideo }
            onChange={ (e): void => setGenerateVideo(e.target.checked) }
            disabled={ isGeneratingImage }
          />
          <Typography color={ isGeneratingImage ? 'grey' : 'default' }>
            Generate video
          </Typography>
        </Label>
        <Button
          variant='primary'
          onClick={ (): Promise<void> => generatePlacement(generateVideo) }
          disabled={ !sceneImage }
          loading={ isGeneratingImage }
          iconStart={ <ImageIcon /> }
        >
          Generate image
        </Button>
      </div>
    </div>
  );
};

